import { FC } from 'react'
import { IUser } from 'screens/Admin/RolesAndUsers/users.types'
import userRolesConstants from 'screens/Users/constants/userRole'
import Dropdown from 'shared/Inputs/Dropdown'

interface IProps {
  selectedRole?: IUser['userRole']
  onChangeRole?: (role: IUser['userRole'], name: string) => void
}

const UserRolesDivider: FC<IProps> = (props) => {

  return (
    <Dropdown
      options={userRolesConstants.rolesOptions}
      selectedOption={props.selectedRole}
      title='Выберите роль'
      name='userRole'
      onSelect={props.onChangeRole}
      getOptionLabel={(o) => userRolesConstants.rolesMap[o]}
      allowEmpty={false}
    />
  )
}

export default UserRolesDivider
